import { FETCH_VPN_STATUS, VPN_START, VPN_STOP } from './constants';

export function fetchVpnStatus() {
  return { type: FETCH_VPN_STATUS };
}

export function vpnStart() {
  return { type: VPN_START };
}

export function vpnStop() {
  return { type: VPN_STOP };
}
